// extracted by css-extract-rspack-plugin
export default {"root":"root-S310RA"};